export default {
  components: {
    TheHeader: () => import("@layout/TheHeader"),
    TheFooter: () => import("@layout/TheFooter"),
  },
  computed: {
    isShowHeader() {
      return !this.$globalIsLiffClient || this.$route.meta.liffShowMenu !== false
    },
    isShowFooter() {
      return !this.$globalIsLiffClient || this.$route.meta.liffShowMenu !== false
    }
  },
}
